// import { stringify } from 'querystring';

// let MUP = mup.markup;
let MUP = 1;


// strip calculator comes here

// The thickness of one skin
const skin = 2.5;
// Set markup to 2, later it will be lookedup.
// 22/11/2019 : standard cutting cost (1.93) of a 10 x 'any' strip  (As per RRheeder)
// cuttingcost = (1.93 / 10) * stripThick
const stdCuttingCost = 1.93;
const commonThickness = 10;
// Rate for a 3mm rubber strip
const rubberRateConstant = (200 / 3);

// 10m in 5 min = 2m per minute = 120/hr => 1/120 = 0.00833333 (for 2 meters)
// This means that the factor for 1 m = 0.004166667
const PSAapplication = 1 / 120;
const bulking = 1 / 40;
const splitting = 1 / 200;

// Setup for sqMPrice
// const sqMPrice = 0;  Not used

// Setup for yield
let yld = 0;

// setup for OH_L
let OH_L = 0;

const materialBuilder = (matReceived, thickness) => {
    const arMat = matReceived.split(' ');
    // const al = arMat.Length;
    arMat[0] = thickness;
    let newMaterial = '';
    arMat.forEach(element => {
        newMaterial += element;
        newMaterial += ' ';
    });
    console.warn('Mat:', newMaterial);
    return newMaterial;
};

const matInformation = desc => {
    let thk = '';
    let wid = 0;
    // console.log(desc);
    // const myThk = 3;
    if (desc) {
        // myname = desc.substr(0, 2);
        thk = desc.split(' ')[0] * 1;
        wid = desc.split(' ')[2] * 1;
    }
    return { thk, wid };
};
// eslint-disable-next-line func-names
// const strcalc = function (type, mySize, myWid) {
//     let matpr = 400.49;
//     let stripPrice = 0;
//     matpr /= 43;
//     // console.log(mySize);
//     matpr *= mySize;

//     matpr /= myWid;
//     if (type === 'plpl') {
//         stripPrice = 1 * matpr;
//     }
//     else if (type === 'plho') {
//         stripPrice = (1 * matpr) * 1.2;
//     }
//     else if (type === 'plco') {
//         stripPrice = (1 * matpr) * 1.4;
//     }
//     if (type === 'pspl') {
//         stripPrice = (1.2 * matpr) + (7 * 0.21);
//     }
//     else if (type === 'psho') {
//         stripPrice = ((1.2 * matpr) + (7 * 0.21)) * 1.2;
//     }
//     else if (type === 'psco') {
//         stripPrice = ((1.2 * matpr) + (7 * 0.21)) * 1.4;
//     }
//     // alert(stripPrice);
//     return stripPrice;
// };
// eslint-disable-next-line func-names
// const mtrstrips = function (mySize, myWid) {
//     const price = [
//         {
//             key: 1,
//             type: 'Plain',
//             plainstr: strcalc('plpl', mySize, myWid),
//             holestr: strcalc('plho', mySize, myWid),
//             compstr: strcalc('plco', mySize, myWid),
//             unit: 'M'
//         },
//         {
//             key: 2,
//             type: 'PSA',
//             plainstr: strcalc('pspl', mySize, myWid),
//             holestr: strcalc('psho', mySize, myWid),
//             compstr: strcalc('psco', mySize, myWid),
//             unit: 'M'
//         }
//     ];
//     return price;
// };
function getSheetQty(bT, sT) {
    let noOfSheets = 0;
    // debugger;
    noOfSheets = (bT - (2 * skin)) / sT;
    // Number of sheets per block without a skin
    // console.log('No of Sheets_Now', noOfSheets);
    return noOfSheets;
}

function getSheetmmCost(sqty, mlen, mPrice, psaCst, mT, div, isPsa) {
    let sPrice;
    // debugger;
    if (isPsa) {
        // sht price with PSA - per meter price
        if (div === 'S') {
            sPrice = ((mPrice / mT) / (mlen / 1000)) + (psaCst);
        }
        else {
            sPrice = (mPrice) + (psaCst);
        }
    }
    else if (div === 'S') { // sht price withou PSA
        sPrice = (mPrice / (mlen / 1000)) / mT;
    }
    else {
        // This results in sheet cost NOT mm Cost
        sPrice = (mPrice);
    }
    // console.log('Sheet mm Price:', sPrice);
    // sheet price with or without PSA
    return sPrice;
}
function getYield(div, stripInfo, MatInfo, strwid) {
    // console.log(div);
    let sW = 0;
    // debugger;
    if (div === 'R') {
        // console.log(MatInfo.Length, parseInt(stripInfo.Length));
        const mL = MatInfo.Length;
        const mW = parseInt(MatInfo.Width, 10);
        const sL = stripInfo.Length;
        // const sL = 1000;
        if (stripInfo.Width === strwid) {
            sW = parseInt(stripInfo.Width, 10);
        }
        else {
            sW = parseInt(strwid, 10);
        }

        yld = parseInt(mW / (sW + (stripInfo.Thickness < 10 ? 0 : 1)), 10);
        if (sL > 1000) {
            yld *= 1;
        }
        else {
            yld *= ((mL / (mL / 1000)) / sL);
        }

        // console.log(mW, sW + 1, 'Yld', yld);
        // return yld;
    }

    if (div === 'S') {
        // console.log(MatInfo.Length, parseInt(stripInfo.Length));
        const bL = MatInfo.Length;
        const bW = parseInt(MatInfo.Width, 10);
        const sL = stripInfo.Length;
        // debugger;
        if (parseInt(stripInfo.Width, 10) === strwid) {
            sW = parseInt(stripInfo.Width, 10);
        }
        else {
            sW = parseInt(strwid, 10);
        }
        const calcSL = sL > 1000 ? 1000 : sL;
        yld = parseInt(bW / (sW + 1), 10);
        yld *= ((bL / (bL / 1000) / calcSL));

        // console.log(bW, sW, 'Yld', yld);
        // return yld;
    }
    if (div === 'I') {
        // console.log(MatInfo.Length, parseInt(stripInfo.Length));
        const mL = MatInfo.Length;
        const mW = parseInt(MatInfo.Width, 10);
        const sL = stripInfo.Length;
        if (parseInt(stripInfo.Width, 10) === strwid) {
            sW = parseInt(stripInfo.Width, 10);
        }
        else {
            sW = parseInt(strwid, 10);
        }

        yld = parseInt(mW / (sW + 1), 10);
        if (sL > 1000) {
            yld *= 1;
        }
        else {
            yld *= ((mL / (mL / 1000)) / sL);
        }

        // console.log(mW, sW, yld);
        // return yld;
    }

    return yld;
}
const calculateStripPrice = (matInfo, stripInfo, ohl) => {
    OH_L = ohl.OHL;
    MUP = (1 + (ohl.markup / 100));

    // console.log('ChkOHL:' , OH_L, 'ChkMUP:' , MUP);
    // debugger;
    let rubberRateFact = 1;
    if (stripInfo.Thickness > 10) {
        rubberRateFact = OH_L / 30;
    }
    else {
        rubberRateFact = OH_L / rubberRateConstant;
    }
    // console.log('ChkRubRate:' , rubberRateFact, 'ChkRRConst:' , rubberRateConstant);
    let materialThickness = matInfo.Thickness;
    let calcSheetsQty = 1;
    let div = 'R';
    if (matInfo.division === 'Sponge') div = 'S';
    if (matInfo.division === 'I.G.M.') div = 'I';
    // console.log('OH&L', OH_L, 'PsaFlag', matInfo.Psa , 'Premium', matInfo.Premium);
    if (div === 'S') {
        // get Number of sheets (Blk Thk & Str Thk) as an Integer
        materialThickness -= (2 * skin);
        calcSheetsQty = parseInt(getSheetQty(matInfo.Thickness, stripInfo.Thickness), 10);
    }

    // Calling this once as we add the PSA later
    const sheetCostPlain = getSheetmmCost(calcSheetsQty, matInfo.Length, matInfo.Price, matInfo.PsaCost, materialThickness, div, false);
    // console.log('sheetmmcost', sheetCostPlain);
    // get yield per sheet
    // debugger;
    const strwid = parseInt(stripInfo.Width, 10);
    const yieldPerSht = getYield(div, stripInfo, matInfo, strwid);
    // console.log('Yield:', yieldPerSht);

    // We use sheetCostPlain as later we add the psa (NB This is a mm sheet price)
    const sheetCostPsa = sheetCostPlain;
    let stripPricePlain = 0;
    let stripPricePSA = 0;
    let cuttingCost = 1;
    if (div === 'S') {
        cuttingCost = (stdCuttingCost / commonThickness) * stripInfo.Thickness;
        console.warn('cutcst', cuttingCost, 'For thk', stripInfo.Thickness);
    }
    else if (stripInfo.Length > 1000) {
        cuttingCost = rubberRateFact * (stripInfo.Length / 1000);
    }
    else {
        cuttingCost = rubberRateFact;
        // console.log('cutcst',cuttingCost);
    }
    // debugger;
    if (div === 'S') {
        stripPricePlain = (sheetCostPlain * stripInfo.Thickness) / yld;
        stripPricePSA = ((sheetCostPsa * stripInfo.Thickness) + matInfo.PsaCost) / yld;
        console.warn('Strip Plain Cst', stripPricePlain, 'Strip PSA Cst', stripPricePSA);
    }
    else if (stripInfo.Length > 1000) {
        stripPricePlain = (sheetCostPlain / (stripInfo.Length / 1000)) / yld;
        stripPricePSA = ((sheetCostPsa + matInfo.PsaCost) * (stripInfo.Length / 1000)) / yld;
    }
    else {
        stripPricePlain = sheetCostPlain / yld;
        stripPricePSA = (sheetCostPsa + matInfo.PsaCost) / yld;
    }
    // matInfo.Premium = 1.7;
    stripPricePlain *= matInfo.Premium;
    stripPricePSA *= matInfo.Premium;

    // console.log('Fact:', PSAapplication, 'sL:', stripInfo.Length / 1000);

    const PSAapplicationCost = ((PSAapplication * (stripInfo.Length / 1000)) / yieldPerSht) * OH_L;
    console.warn('PSA App ', PSAapplicationCost);
    const bulkingCost = ((bulking * (stripInfo.Length / 1000)) / yieldPerSht) * OH_L;

    console.warn('Bulking', bulkingCost, ' for a Yld of ', yieldPerSht);
    const splittingCost = ((splitting * (stripInfo.Length / 1000)) / yieldPerSht) * OH_L;
    console.warn('Splitting ', splittingCost);
    console.warn('calcSht:', calcSheetsQty, matInfo.Price, yld);
    console.warn('Costs - PSA - Yld:', sheetCostPlain, sheetCostPsa, matInfo.PsaCost, yld);
    // console.log('Plain Price: ', stripPricePlain, 'PSA Price:', stripPricePSA);
    // console.log('Cutting Cost', cuttingCost);
    // console.log('PSAAppl:', PSAapplicationCost);
    // console.log('Bulking:', bulkingCost);
    // console.log('Splitting:', splittingCost);
    // console.log('MUP:', MUP);
    // debugger;
    let plainPrice = 0;
    let psaPrice = 0;
    if (div === 'S') {
        plainPrice = (stripPricePlain * (stripInfo.Length / 1000)) + bulkingCost + splittingCost + cuttingCost;
        psaPrice = (stripPricePSA * (stripInfo.Length / 1000)) + bulkingCost + PSAapplicationCost + splittingCost + cuttingCost;
    }
    else if (stripInfo.Length > 1000) {
        plainPrice = (stripPricePlain) + cuttingCost;
        psaPrice = (stripPricePSA) + cuttingCost;
    }
    else {
        plainPrice = (stripPricePlain * (stripInfo.Length / 1000)) + cuttingCost;
        psaPrice = (stripPricePSA * (stripInfo.Length / 1000)) + cuttingCost;
    }
    plainPrice *= MUP;
    psaPrice *= MUP;
    const plainHolesPrice = plainPrice * 1.4;
    const psaHolesPrice = psaPrice * 1.4;
    const plainComplexPrice = plainHolesPrice * 1.4;
    const psaComplexPrice = psaHolesPrice * 1.4;

    // console.log('Plain:', plainPrice);
    // console.log('PSA:', psaPrice);
    // console.log('PlHoles:', plainHolesPrice);
    // console.log('PSAHoles:', psaHolesPrice);
    // console.log('PlComplex:', plainComplexPrice);
    // console.log('PSAComplex:', psaComplexPrice);

    const price = [
        {
            key: 1,
            type: 'Plain',
            plainstr: plainPrice,
            holestr: plainHolesPrice,
            compstr: plainComplexPrice,
            unit: 'M'
        },
        {
            key: 2,
            type: 'PSA',
            plainstr: psaPrice,
            holestr: psaHolesPrice,
            compstr: psaComplexPrice,
            unit: 'M'
        }
    ];

    // console.log('Caller:', price);

    return price;
};

const calculateSheetPrice = (matInfo, stripInfo, ohl, recThk, div) => {
    // debugger;
    OH_L = ohl.OHL;
    MUP = (1 + (ohl.markup / 100));
    // console.log('OH&L', OH_L, 'MUP', MUP);

    // let plainPrice = 10;
    // let psaPrice = 12;
    let shts = 1;
    if (div === 'Sponge') {
        shts = parseInt(getSheetQty(matInfo.Thickness, recThk), 10);
    }
    // console.log('Thk:', matInfo.Thickness, recThk, 'Shts:', shts);
    if (div === 'Sponge') div = 'S';
    let sheetCostPlain = getSheetmmCost(shts, matInfo.Length, matInfo.Price, matInfo.PsaCost, matInfo.Thickness, div, false);
    // const sheetCostPSA = getSheetmmCost(shts, matInfo.Length, matInfo.Price, matInfo.PsaCost, matInfo.Thickness, div, true);
    sheetCostPlain *= matInfo.Premium;
    // sheetCostPsa *= matInfo.Premium;
    // debugger;
    // console.log('sheetmmcost', sheetCostPlain, 'SheetCst',matInfo.Price);
    sheetCostPlain *= (matInfo.Length / 1000);
    if (div === 'S') sheetCostPlain *= recThk;

    sheetCostPlain *= MUP;
    // console.log('ShtCost:', sheetCostPlain);
    const psaPrice = sheetCostPlain + matInfo.PsaCost;

    const price = [
        {
            key: 1,
            type: 'Plain',
            // plainstr: plainPrice,
            plainstr: sheetCostPlain,
            unit: 'Sht'
        },
        {
            key: 2,
            type: 'PSA',
            plainstr: psaPrice,
            unit: 'Sht'
        }
    ];
    // console.log('Caller2:', price);
    return price;
};

const calculateTableStripPrice = (matInfo, stripInfo, ohl, wid, mykey) => {
    OH_L = ohl.OHL;
    MUP = (1 + (ohl.markup / 100));
    // console.log('TBChkOHL:' , OH_L, 'TBChkMUP:' , MUP);

    // console.log ('StrWidth:', wid);
    // console.log('StripWid:', stripInfo.Width);
    let rubberRateFact = 0;
    if (stripInfo.Thickness > 10) {
        rubberRateFact = OH_L / 30;
    }
    else {
        rubberRateFact = OH_L / rubberRateConstant;
    }
    // console.log('TBChkRubRate:' , rubberRateFact, 'TBChkRRConst:' , rubberRateConstant);

    let materialThickness = matInfo.Thickness;
    let calcSheetsQty = 1;
    let div = 'R';
    if (matInfo.division === 'Sponge') div = 'S';
    if (matInfo.division === 'I.G.M.') div = 'I';
    // console.log('OH&L', OH_L, 'PsaFlag', matInfo.Psa , 'Premium', matInfo.Premium);
    if (div === 'S') {
        // get Number of sheets (Blk Thk & Str Thk) as an Integer
        materialThickness -= (2 * skin);
        calcSheetsQty = parseInt(getSheetQty(matInfo.Thickness, stripInfo.Thickness), 10);
    }

    // Calling this once as we add the PSA later
    // let matLength = 1000;
    const matLength = stripInfo.Length;
    const sheetCostPlain = getSheetmmCost(calcSheetsQty, matLength, matInfo.Price, matInfo.PsaCost, materialThickness, div, false);
    // console.log('sheetmmcost', sheetCostPlain);
    // get yield per sheet
    // debugger;
    const yieldPerSht = getYield(div, stripInfo, matInfo, wid);
    // console.log('Yield:', yieldPerSht);

    // We use sheetCostPlain as later we add the psa (NB This is a mm sheet price)
    const sheetCostPsa = sheetCostPlain;
    let stripPricePlain = 0;
    let stripPricePSA = 0;
    let cuttingCost = 0;
    if (div === 'S') {
        cuttingCost = (stdCuttingCost / commonThickness) * stripInfo.Thickness;
    }
    else if (matLength > 1000) {
        cuttingCost = rubberRateFact * (matLength / 1000);
    }
    else {
        cuttingCost = rubberRateFact;
    }

    if (div === 'S') {
        stripPricePlain = (sheetCostPlain * stripInfo.Thickness) / yld;
        stripPricePSA = ((sheetCostPsa * stripInfo.Thickness) + matInfo.PsaCost) / yld;
    }
    else if (matLength > 1000) {
        stripPricePlain = (sheetCostPlain * (matLength / 1000)) / yld;
        stripPricePSA = ((sheetCostPsa + matInfo.PsaCost) * (matLength / 1000)) / yld;
    }
    else {
        stripPricePlain = sheetCostPlain / yld;
        stripPricePSA = (sheetCostPsa + matInfo.PsaCost) / yld;
    }
    // matInfo.Premium = 1.7;
    stripPricePlain *= matInfo.Premium;
    stripPricePSA *= matInfo.Premium;

    // console.log('Fact:', PSAapplication, 'sL:', matLength / 1000);

    const PSAapplicationCost = ((PSAapplication * (matLength / 1000)) / yieldPerSht) * OH_L;
    // console.log('PSA App Table ', PSAapplicationCost);
    const bulkingCost = ((bulking * (matLength / 1000)) / yieldPerSht) * OH_L;
    // console.log('Bulking Table ', bulkingCost, ' for a Yld of ', yieldPerSht);
    const splittingCost = ((splitting * (matLength / 1000)) / yieldPerSht) * OH_L;
    // console.log('Splitting Table ', splittingCost);
    // console.log('calcSht:', calcSheetsQty, matInfo.Price, yld);
    // console.log('Costs - PSA - Yld:', sheetCostPlain, sheetCostPsa, matInfo.PsaCost, yld);
    // console.log('Plain Price: ', stripPricePlain, 'PSA Price:', stripPricePSA);
    // console.log('Cutting Cost', cuttingCost);
    // console.log('PSAAppl:', PSAapplicationCost);
    // console.log('Bulking:', bulkingCost);
    // console.log('Splitting:', splittingCost);
    // console.log('MUP:', MUP);

    // debugger;
    let plainPrice = 0;
    let psaPrice = 0;
    // console.log('matLength ', matLength);
    if (div === 'S') {
        plainPrice = (stripPricePlain * (matLength / 1000)) + bulkingCost + splittingCost + cuttingCost;
        psaPrice = (stripPricePSA * (matLength / 1000)) + bulkingCost + PSAapplicationCost + splittingCost + cuttingCost;
        console.warn('Plain  ', plainPrice, ' PSA ', psaPrice, stripPricePlain, stripPricePSA);
    }
    else if (matLength > 1000) {
        plainPrice = (stripPricePlain) + cuttingCost;
        psaPrice = (stripPricePSA) + cuttingCost;
    }
    else {
        plainPrice = (stripPricePlain * (matLength / 1000)) + cuttingCost;
        psaPrice = (stripPricePSA * (matLength / 1000)) + cuttingCost;
    }
    plainPrice *= MUP;
    psaPrice *= MUP;
    const plainHolesPrice = plainPrice * 1.4;
    const psaHolesPrice = psaPrice * 1.4;
    const plainComplexPrice = plainHolesPrice * 1.4;
    const psaComplexPrice = psaHolesPrice * 1.4;

    // console.log('gp Plain:', plainPrice);
    // console.log('PSA:', psaPrice);
    // console.log('PlHoles:', plainHolesPrice);
    // console.log('PSAHoles:', psaHolesPrice);
    // console.log('PlComplex:', plainComplexPrice);
    // console.log('PSAComplex:', psaComplexPrice);

    const tabprice = [
        {
            key: mykey,
            type: wid,
            plainstr: plainPrice,
            holestr: plainHolesPrice,
            compstr: plainComplexPrice,
            psaplstr: psaPrice,
            psaholestr: psaHolesPrice,
            psacompstr: psaComplexPrice,
        }
    ];

    // console.log('Caller:', tabprice);

    return tabprice;
};

// temp data for the material - will be done from the DataBase later
export default {
    calculateStripPrice,
    calculateSheetPrice,
    calculateTableStripPrice,
    materialBuilder,
    matInformation
};




// WEBPACK FOOTER //
// ./src/util/GetStripPrice.js